// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-bubble[data-v-94c02778]{word-break:break-word}", ""]);
// Exports
module.exports = exports;
